"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  OfficeStampDocument: ['office-stamp-document', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,6V1.727A.975.975,0,0,1,7.721.748h9.7l5.824,5.87V22.27a.975.975,0,0,1-.971.978H15.75', 'M17.25.748v5a1,1,0,0,0,1,1h5', 'M20.804 10.498L12.75 10.498', 'M20.804 19.498L18 19.498', 'M20.804 14.998L14.25 14.998', 'M0.75 20.248L1.5 23.248 12 23.248 12.75 20.248', 'M9.75,17.248H8.25V14.582a3,3,0,1,0-3,0v2.666H3.75a3,3,0,0,0-3,3h12A3,3,0,0,0,9.75,17.248Z']],
  OfficePrinter: ['office-printer', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,9.748V7.5A1.5,1.5,0,0,1,2.25,6h19.5a1.5,1.5,0,0,1,1.5,1.5v.75a1.5,1.5,0,0,1-1.5,1.5Z', 'M3.75 5.998L21.294 0.748', 'M.75,9.748V22.27a.978.978,0,0,0,.978.978H22.272a.978.978,0,0,0,.978-.978V15.227a.978.978,0,0,0-.978-.979H19.337l-1.957,1.5H13.5v-6', 'M0.75 20.248L23.25 20.248', 'M13.5 15.748L11.511 15.748', 'M3.75 12.748L3.75 14.998', 'M6.75 12.748L6.75 14.998']],
  OfficeLamp: ['office-lamp', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.422 9.345L11.191 4.618', 'M17.531 18.545L21.112 11.384', 'M20.250 10.042 A1.500 1.500 0 1 0 23.250 10.042 A1.500 1.500 0 1 0 20.250 10.042 Z', 'M10.125,11.264a1.305,1.305,0,0,0,.369-1.107l-.6-4.2,1.038-1.038A2.446,2.446,0,1,0,7.473,1.465L6.435,2.5l-4.2-.6A1.3,1.3,0,0,0,1.132,4.116L8.28,11.264A1.3,1.3,0,0,0,10.125,11.264Z', 'M20.649,23.248a.978.978,0,0,0,.93-1.28,5.8,5.8,0,0,0-5.666-3.611,5.8,5.8,0,0,0-5.666,3.611.978.978,0,0,0,.93,1.28Z']],
  OfficeDrawer: ['office-drawer', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.814 L23.250 12.814 L23.250 23.249 L0.750 23.249 Z', 'M2.25,12.814V6.977A.983.983,0,0,1,3.237,6h8.388a.987.987,0,0,1,.789.392L13.6,8.248h6.414A.983.983,0,0,1,21,9.227v3.587', 'M9.065 15.748L14.935 15.748', 'M19.737,5.248V3.977A.983.983,0,0,0,18.75,3H13.6L12.414,1.14a.987.987,0,0,0-.789-.392H4.5a.983.983,0,0,0-.987.979V2.77']],
  OfficeFolder: ['office-folder', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.286,12.433a1,1,0,0,0-.979-1.193H10.479a1,1,0,0,1-.978-.8L9.224,9.049a1,1,0,0,0-.978-.8H1.8A1,1,0,0,0,.825,9.442L3.418,22.447a1,1,0,0,0,.978.8H20.313a1,1,0,0,0,.978-.8C21.7,20.39,22.8,14.868,23.286,12.433Z', 'M4.556,5.248l.02-3.5a1,1,0,0,1,1-1H18.538a1,1,0,0,1,1,1l.021,6.5', 'M7.568 3.74L15.806 3.748', 'M12.056 6.748L15.806 6.748']],
  OfficeClipper: ['office-clipper', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,11.248H2.25A1.5,1.5,0,0,0,.776,13.025l1.688,9a1.5,1.5,0,0,0,1.474,1.223H20.062a1.5,1.5,0,0,0,1.474-1.223l1.688-9A1.5,1.5,0,0,0,21.75,11.248Z', 'M17.25,3.748c0-1.656-2.35-3-5.25-3s-5.25,1.344-5.25,3c0,1.029.909,1.936,2.291,2.477L7.5,23.248h9L14.959,6.225C16.341,5.684,17.25,4.777,17.25,3.748Z']],
  OfficeFolder1: ['office-folder-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.875,23.248H3.447a.819.819,0,0,1-.822-.815V1.727A.983.983,0,0,1,3.612.748H20.388a.983.983,0,0,1,.987.979V4.5', 'M21.375 17.674L16.875 19.701 16.875 13.113 21.375 11.086 21.375 17.674z', 'M21.375,22.235c0,.56-.672,1.013-1.5,1.013h-3V19.7l4.5-2.027Z', 'M21.375,11.087l-4.5,2.026V7.539a2.063,2.063,0,0,1,1.248-1.576L21.375,4.5Z']],
  OfficeTape2: ['office-tape-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.875 4.123L16.407 10.136', 'M13.125 13.123 A3.000 3.000 0 1 0 19.125 13.123 A3.000 3.000 0 1 0 13.125 13.123 Z', 'M16.125,12.748a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M6.838,14.29a1.467,1.467,0,0,1-2.713-.775v-2.8A2.936,2.936,0,0,0,2.717,8.429l-.778-.6c-.448-.3-.814-.1-.814.436v7.7a3.913,3.913,0,0,0,3.913,3.913H16.125a6.75,6.75,0,0,0,0-13.5C12.589,6.373,10.311,8.709,6.838,14.29Z']],
  OfficeBusinessCard: ['office-business-card', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25,5.623H22.272a.977.977,0,0,1,.978.971V21.153a.977.977,0,0,1-.978.97H1.728a.977.977,0,0,1-.978-.97V6.594a.977.977,0,0,1,.978-.971H5.25', 'M12 12.373L20.25 12.373', 'M6.75 16.873L20.25 16.873', 'M3.75,5.623v-1.5A2.25,2.25,0,0,1,6,1.873H6a2.25,2.25,0,0,1,2.25,2.25v6.75a1.5,1.5,0,0,1-1.5,1.5h0a1.5,1.5,0,0,1-1.5-1.5V8.623']],
  OfficeHolePuncher: ['office-hole-puncher', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.132,4.824l-1.01,7.068a.75.75,0,0,0,.743.856H7.588a.749.749,0,0,0,.744-.657l.5-4.029a1.5,1.5,0,0,1,1.488-1.314h3.352a1.5,1.5,0,0,1,1.488,1.314l.5,4.029a.749.749,0,0,0,.744.657h3.723a.75.75,0,0,0,.743-.856l-1.01-7.068A3,3,0,0,0,16.9,2.248H7.1A3,3,0,0,0,4.132,4.824Z', 'M5.25 12.748L5.25 15.748', 'M18.75 12.748L18.75 15.748', 'M22.5 15.748L23.25 18.748 0.75 18.748 1.5 15.748', 'M23.25,18.748H.75v1.5a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5Z']],
  OfficeFolderSealed: ['office-folder-sealed', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 0.748 L20.250 0.748 L20.250 23.248 L3.750 23.248 Z', 'M20.067,22.825,17.492,20.16a2.238,2.238,0,0,0-1.609-.662H8.118a2.239,2.239,0,0,0-1.61.662L3.933,22.825', 'M10.500 5.248 A1.500 1.500 0 1 0 13.500 5.248 A1.500 1.500 0 1 0 10.500 5.248 Z', 'M10.500 14.248 A1.500 1.500 0 1 0 13.500 14.248 A1.500 1.500 0 1 0 10.500 14.248 Z', 'M12 6.748L12 12.748', 'M15.75,7.5h1.169a1.5,1.5,0,0,0,1.423-1.025L20.1,1.222', 'M3.905,1.213l1.753,5.26A1.5,1.5,0,0,0,7.081,7.5H8.25']],
  OfficeGlue: ['office-glue', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,11.248H8.25V9A.75.75,0,0,1,9,8.248h6a.75.75,0,0,1,.75.75Z', 'M9.75,8.248l1.532-6.789c.213-.948,1.223-.948,1.436,0L14.25,8.248', 'M5.250 11.248 L18.750 11.248 L18.750 23.248 L5.250 23.248 Z', 'M5.25 14.248H18.75V20.247999999999998H5.25z']],
  OfficeShelfCorner: ['office-shelf-corner', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.375 9.373H16.875V21.372999999999998H3.375z', 'M16.875,9.373H3.375v-3h10.5a1.5,1.5,0,0,1,1.2.6Z', 'M3.375 6.373L10.125 1.123', 'M16.875 19.873L20.625 16.873', 'M16.875 15.373L20.625 12.373', 'M7.125 12.373L13.125 12.373', 'M7.125 16.873L13.125 16.873', 'M3.375 21.373L3.375 22.873', 'M16.875 21.373L16.875 22.873']],
  OfficeShredder1: ['office-shredder-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25,9.748V1.787A1.039,1.039,0,0,1,6.288.748h6.551a1.035,1.035,0,0,1,.734.3l4.873,4.872a1.038,1.038,0,0,1,.3.734V9.748', 'M18.75,6.748H13.788A1.038,1.038,0,0,1,12.75,5.71V.748', 'M3.75,17.248H2.25a1.5,1.5,0,0,1-1.5-1.5v-4.5a1.5,1.5,0,0,1,1.5-1.5h19.5a1.5,1.5,0,0,1,1.5,1.5v4.5a1.5,1.5,0,0,1-1.5,1.5h-3', 'M5.25 14.248L17.25 14.248', 'M9.75 14.248L9.75 23.248', 'M12.75 14.248L12.75 23.248', 'M6.75,14.248v6a1.5,1.5,0,0,1-1.5,1.5H4.5', 'M15.75,14.248v6a1.5,1.5,0,0,0,1.5,1.5H18', 'M20.625,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  OfficeShelf1: ['office-shelf-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(4.243 -7.108) rotate(24.902)'
  }], ['M3 0.748L3 23.248', 'M21 0.748L21 23.248', 'M1.5 20.248L22.5 20.248', 'M1.5 9.748L22.5 9.748', 'M6 2.998H9V9.748000000000001H6z', 'M6.75 13.498H9.75V20.247999999999998H6.75z', 'M12.75 13.498H15.75V20.247999999999998H12.75z', 'M9.75 14.998H12.75V20.247999999999998H9.75z', 'M9 2.998H12V9.748000000000001H9z', 'M16.718 2.681H19.718V9.431000000000001H16.718z']],
  OfficeStapler1: ['office-stapler-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.7,14.846,13.962,1.8a3,3,0,0,1,4.23-.326l.524.449a1.5,1.5,0,0,1,.163,2.115L7.5,17.226', 'M7.5,17.248h0a3,3,0,0,0-3-3h0a3,3,0,0,0-3,3v1.5a1.5,1.5,0,0,0,1.5,1.5H21.749a.75.75,0,0,0,.6-1.2l-.45-.6a3,3,0,0,0-2.4-1.2Z', 'M18.384 4.612L20.662 6.564 14.787 13.421 12.51 11.47', 'M21.75,20.248l-.608,2.432a.749.749,0,0,1-.728.568H4.336a.749.749,0,0,1-.728-.568L3,20.248']],
  OfficeStapler: ['office-stapler', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,18.362H21v2.813a.98.98,0,0,1-1.012.937H2.269c-1.2,0-1.519-.469-1.519-1.875Z', 'M22.988,15.4a1.063,1.063,0,0,0-.081-1.464L10.126,2.573c-.9-.711-1.758-.837-2.549.048L5.707,4.642,21.049,17.716Z', 'M6.573 5.421L4.162 8.406', 'M2.25 18.362L2.25 15.362', 'M10.5,18.362a8.242,8.242,0,0,1,3.44-6.7']],
  OfficeTape: ['office-tape', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.624,11.828a3.221,3.221,0,0,1-3.194,2.8h0a3.223,3.223,0,0,1-3.1-2.336l-.521-1.826A1.5,1.5,0,0,0,3.369,9.373H2.25a1.5,1.5,0,0,0-1.5,1.5v4.5a4.5,4.5,0,0,0,4.5,4.5h15a3,3,0,0,0,3-3v-7.1A5.652,5.652,0,0,0,17.6,4.123h0a5.64,5.64,0,0,0-3.349,1.1', 'M15.000 9.748 A2.625 2.625 0 1 0 20.250 9.748 A2.625 2.625 0 1 0 15.000 9.748 Z', 'M16.754 7.271L4.955 10.966']],
  OfficeTape1: ['office-tape-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.466,13.1a6,6,0,1,1,11.747-2.267', 'M11.43,12.524A3,3,0,1,1,17.248,11.4', 'M0.75 6.835L8.699 9.22', 'M22.764,17.605a1.957,1.957,0,0,1-1.817,1.23H4.234a1.956,1.956,0,0,1-1.9-1.482L.869,11.484A3.964,3.964,0,0,1,.75,10.52a.489.489,0,0,1,.489-.489H1.98a2.932,2.932,0,0,1,2.075.86l1.462,1.462a2.937,2.937,0,0,0,2.633.806l11.9-2.3a1.957,1.957,0,0,1,2.246,1.359l.818,2.728a3.307,3.307,0,0,1,.141.958,2.539,2.539,0,0,1-.182.943Z']],
  OfficeRazor: ['office-razor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.207,15.372,7.649,11.813a.838.838,0,0,1,0-1.186l8.9-8.9a3.355,3.355,0,0,1,4.744,0h0a3.347,3.347,0,0,1,.007,4.74c-2.808,2.806-7.31,7.308-8.909,8.907A.832.832,0,0,1,11.207,15.372Z', 'M11.207,15.372,7.649,11.813,2,17.466a.841.841,0,0,0-.243.669l.4,4.349A.839.839,0,0,0,3.577,23Z', 'M9.428 13.592L15.359 7.662', 'M15.952 2.324L20.696 7.069', 'M5.869 13.592L6.463 20.116']],
  OfficeEraser: ['office-eraser', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25 19.498L21 19.498', 'M21,22.27a1.034,1.034,0,0,1-1.083.978H12.333a1.034,1.034,0,0,1-1.083-.978V1.727A1.035,1.035,0,0,1,12.333.748h7.678A.952.952,0,0,1,21,1.727Z', 'M14.25 3.54L14.25 4.498', 'M18 3.54L18 4.498', 'M11.25 7.498L21 7.498', 'M14.25 10.498L14.25 16.498', 'M18 10.498L18 16.498', 'M11.25,6.018c-3.507,2.551-7.185,5.668-8.1,10.111a5.336,5.336,0,0,0,0,2.525c.972,3.424,4.818,2.737,8.1,2.681']],
  OfficeSignDocument: ['office-sign-document', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.164,13.293a2.3,2.3,0,0,1,3.211-.092,2.3,2.3,0,0,1-.092,3.21c-.881.883-4.752,1.632-4.752,1.632S8.283,14.174,9.164,13.293Z', 'M12.73,5.568l3.639-3.639a1.47,1.47,0,0,1,2.079,0l1.04,1.04', 'M11.17,11.286l8.318-8.317a2.211,2.211,0,0,1,3.119,0h0a2.213,2.213,0,0,1,0,3.119l-8.318,8.317Z', 'M16.369 6.088L19.488 9.207', 'M21.22,13.5c0,4.041.425,6.325-1.758,8.508L18.33,23.139a.378.378,0,0,1-.266.109H1.125a.375.375,0,0,1-.265-.64l.6-.6C3.725,19.743,3.22,18.294,3.22,6.234c0-3.148,2.348-4.834,3-5.486h4.448']],
  OfficeStationery: ['office-stationery', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(0.699 -2.32) rotate(9.095)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(41.95 11.893) rotate(-170.905)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.281 0.760 L16.581 0.760 L16.581 5.710 L13.281 5.710 Z', 'M16.69 2.681L18.514 12.164 17.7 17.248', 'M19.798 1.803 L23.098 1.803 L23.098 6.753 L19.798 6.753 Z', 'M19.949 3.203L15.256 11.642 14.25 17.248', 'M5.25,3.748h3.5a1.007,1.007,0,0,1,1,1.008V17.248H5.25Z', 'M7.5 3.748L7.5 0.748', 'M23.25,18.248a1.014,1.014,0,0,0-1.023-1H1.773a1.014,1.014,0,0,0-1.023,1v4a1.014,1.014,0,0,0,1.023,1H22.227a1.014,1.014,0,0,0,1.023-1Z', 'M6 0.748L8.795 0.748', 'M5.25,3.748h0a3,3,0,0,0-3,3V10.5']],
  OfficeShredder: ['office-shredder', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,11.248H3v10.5a1.5,1.5,0,0,0,1.5,1.5h15a1.5,1.5,0,0,0,1.5-1.5Z', 'M7.5,6H5.631A1.5,1.5,0,0,0,4.189,7.086L3,11.248H21L19.811,7.086A1.5,1.5,0,0,0,18.369,6H16.5', 'M16.5,8.248h-9V1.5a.75.75,0,0,1,.75-.75h7.5a.75.75,0,0,1,.75.75Z', 'M12 11.248L12 19.498', 'M9,11.248v1.408a8.483,8.483,0,0,1-1.413,5.417', 'M15,11.248v1.408a8.483,8.483,0,0,0,1.413,5.417']],
  OfficeShelf: ['office-shelf', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.748 L23.250 0.748 L23.250 21.748 L0.750 21.748 Z', 'M0.75 8.248H23.25V11.248H0.75z', 'M0.75 18.748L23.25 18.748', 'M5.25 3.748H8.25V8.248000000000001H5.25z', 'M8.25 3.748H11.25V8.248000000000001H8.25z', 'M11.25 3.748H14.25V8.248000000000001H11.25z', 'M14.25 14.248H17.25V18.747999999999998H14.25z', 'M17.25 14.248H20.25V18.747999999999998H17.25z', 'M6.75 14.248H9.75V18.747999999999998H6.75z', 'M3.75 14.248H6.75V18.747999999999998H3.75z', 'M20.25 14.248H23.25V18.747999999999998H20.25z', 'M17.25 3.748H20.25V8.248000000000001H17.25z', 'M2.25 21.347L2.25 23.248', 'M21.75 21.347L21.75 23.248']]
};
exports["default"] = _default;